import React from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions";

// core components
/*TABS*/
//Styles
import { withStyles } from "tss-react/mui";
import JamezzFormStyles from "../../views/JamezzForm/JamezzFormStyles";
import SubsResellerGeneral from "./Tabs/SubsResellerGeneral";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../utils/formatting";

const endPoint = "core/subsReseller";

function SubsResellerForm() {
  return (
    <AuthProvider prefix={"subsResellers"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.description);
        }}
        endPoint={endPoint}
        mode={"onSubmit"}
        pageTitle={getTranslation("subDebtors.form.pageTitle", "Reseller")}
        revalidateMode={"onChange"}
        tabs={[
          {
            right: "general",
            tabButton: <TranslationWrapper tDefault={"General"} tKey={"subsResellers.form.tabs.general"} />,
            tabContent: <SubsResellerGeneral />,
          },
        ]}
      />
    </AuthProvider>
  );
}

//REDUX
const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SubsResellerForm, JamezzFormStyles));
